<template>
  <div class='login-pc'>
    <div class="page-login--layer">
      <div class="content-main">
        <div class="page-login">
          <div class="content-main-div">
            <div class="header">
              <div class="zhl-flex-c">
                <img class="icon-logo"
                     src="@/assets/images/login/icon-logo-1.png">
              </div>
              <div class="zhl-flex-c business-name">云教英语听说专练系统</div>
            </div>
            <div class="btn zhl-flex-c active"
                 @click="handleBtn">登录</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginPC',
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    handleBtn() {
      // 云南教育云登录
      location.replace('https://djysso.yneducloud.com/login?CLIENTIDENT=djy-yingyutingshuo&REDIRECTURI=https://yjts.yneducloud.com/EnglishHome.html')
    }
  },
  computed: {
    modelLoginFun() {
      return {
        modelLogin14: true
      }
    }
  }
}
</script>

<style lang='less' scoped>
.login-pc {
  user-select: none;
  cursor: pointer;
  height: 100%;
  width: 100%;
  position: relative;
  min-width: 1100px;
  overflow: auto;
  .page-login--layer {
    width: 100%;
    height: 100%;
    &:before {
      width: 650px;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      display: inline-block;
      background: url('../images/login-left.png') no-repeat center;
      background-size: cover;
    }
    &:after {
      width: 300px;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      content: '';
      display: inline-block;
      background: url('../images/login-right.png') no-repeat center;
      background-size: cover;
    }
  }
  .page-login--content {
    height: 100%;
    min-height: 500px;
    position: relative;
    z-index: 2;
  }
  .content-main {
    position: absolute;
    left: 750px;
    top: 28vh;
    background: #fff;
    width: 250px;
    height: 300px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 20px 49px 0 rgba(28, 34, 114, 0.15);
    border-radius: 10px;
    z-index:2;
    .page-login {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      .content-main-div {
        .header {
          padding: 24px 0 25px 0;
          box-sizing: content-box;
          font-size: 22px;
          font-weight: bold;
          color: #333333;

          .icon-logo {
            margin-bottom: 35px;
            display: block;
            width: 35px;
          }
          .business-name {
            font-size: 15px;
          }
        }
        .btn {
          margin: 20px 40px 14px 40px;
          width: 190px;
          height: 31px;
          background: rgba(70, 213, 132, 0.5);
          border-radius: 8px;
          font-size: 14px;
          font-weight: 500;
          color: #ffffff;
          letter-spacing: 2px;
          cursor: pointer;

          &.active {
            background: rgba(70, 213, 132, 1);
          }
        }
      }
    }
  }
  @keyframes fade-in {
    0% {
      opacity: 0;
    } /*初始状态 透明度为0*/
    40% {
      opacity: 0;
    } /*过渡状态 透明度为0*/
    100% {
      opacity: 1;
    } /*结束状态 透明度为1*/
  }
  @-webkit-keyframes fade-in {
    /*针对webkit内核*/
    0% {
      opacity: 0;
    }
    40% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .banner-login {
    animation: fade-in; /*动画名称*/
    animation-duration: 1s; /*动画持续时间*/
    -webkit-animation: fade-in 1s; /*针对webkit内核*/
  }
}
</style>
